import React, { FC } from 'react';

import TicketsFilters from './components/TicketsFilters/TicketsFilters';
import TicketsSearch from './components/TicketsSearch/TicketsSearch';
import TicketsList from './components/TicketsList/TicketsList';
import TicketsPagination from './components/TicketsPagination/TicketsPagination';

import useStyles from './styles';

const TicketsOld: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.tickets}>
      <TicketsFilters />
      <div className={classes.ticketsContent}>
        <TicketsSearch />
        <TicketsList />
        <TicketsPagination />
      </div>
    </div>
  );
};

export default TicketsOld;
